import { Scale } from 'src/app/template/color-scale/models/scale';

export class ResultScale extends Scale {

}
